import { Middleware, Dispatch } from 'redux';
import { IAddress } from 'types/address';
import urlParams from 'libs/query';
import { AppState } from './index';
import { getLegalStatus } from 'components/address/reducer';
import { mobileChecker } from 'components/address/edit/address-checkers';
import { getFreight, getOrderInfo } from './base-reducer';
import { greaterZero } from 'src/utils/common-func';

let temp = false; // 判断地址是否被新增或删减过
export const getFeightByAddress = (address: IAddress, num?: number, campaign_id?: string) => {
    return getFreight({
        area_id: String(address.area_id || ''),
        city_id: String(address.city_id || ''),
        province_id: String(address.prov_id || ''),
        items: [
            {
                product_id: urlParams.product_id || urlParams.id,
                combo_id: urlParams.combo_id,
                combo_num: num || greaterZero(urlParams.combo_num),
                campaign_id: campaign_id,
                group_id: '0' // 数字的字符串
            }
        ]
    });
};

const getStockeByAddress = (address: any, disableToast: boolean) =>
    getOrderInfo(address, disableToast);

/* eslint-disable complexity */
// 这个中间件承担了发送验证码 发送运费计算接口的作用
const sendCodeMiddleware: Middleware<{}, AppState, Dispatch> = (store) => (next) => (action) => {
    const { list: listBefore, selected: selectedBefore } = store.getState().address;
    const baseBefore = store.getState().base;
    const result = next(action);
    const { list: listAfter, selected: selectedAfter } = store.getState().address;
    const baseAfter = store.getState().base;
    const hasFees = baseAfter.goods && baseAfter.goods.freight && selectedAfter;
    if (baseBefore.num !== baseAfter.num && baseAfter.num && hasFees) {
        store.dispatch(
            // @ts-ignore
            getFeightByAddress(
                selectedAfter,
                baseAfter.num,
                baseAfter.campaign && baseAfter.campaign.campaign_id
            )
        );
    }
    // 获取运费需要campaign_id，如果地址接口比orderinfo先返回，在获取到商品后需要发一下
    if (baseBefore.goods !== baseAfter.goods && hasFees) {
        store.dispatch(
            // @ts-ignore
            getFeightByAddress(
                selectedAfter,
                baseAfter.num,
                baseAfter.campaign && baseAfter.campaign.campaign_id
            )
        );
    }
    if (listAfter && listBefore && listBefore.length !== listAfter.length) {
        temp = true;
    }
    // 地址变化重新请求存库和运费
    if (selectedAfter && selectedBefore !== selectedAfter) {
        if (
            selectedBefore &&
            ['prov_id', 'city_id', 'area_id'].filter((x) => selectedBefore[x] !== selectedAfter[x])
                .length
        ) {
            store.dispatch(getStockeByAddress(selectedAfter, temp));
            temp = false;
        }
        // if (
        //     (!selectedBefore ||
        //         selectedBefore.area_id.toString() !== selectedAfter.area_id.toString()) &&
        //     hasFees
        // ) {
        //     store.dispatch(
        //         // @ts-ignore
        //         getFeightByAddress(
        //             selectedAfter,
        //             baseAfter.num,
        //             baseAfter.campaign && baseAfter.campaign.campaign_id
        //         )
        //     );
        // }
    }

    return result;
};

export default sendCodeMiddleware;
